import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "m7.945 9.006 6.885 6.884 1.06-1.06-6.884-6.885 6.884-6.884L14.83 0 7.945 6.884 1.061 0 0 1.06l6.884 6.885L0 14.83l1.06 1.06z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }